import { SET } from "@/stores/CommumActionTypes";
import { UPDATE_USER_IMG_URL } from "./UserActionTypes";
import UsersService from "@/services/common/UsersService";

const actions = {
	[SET]: ({ commit }, user) =>
	{
		commit(SET, user);
	},
	[UPDATE_USER_IMG_URL]: ({ commit }, userId) =>
	{
		const newUrl = UsersService.GetUserProfileUrl(userId);
		commit(UPDATE_USER_IMG_URL, newUrl);
	},
};

export default { actions };
